import {
  type ThemeProviderProps,
  ThemeProvider as ThemeProviderGravity,
} from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";
import { themeAtom } from "src/store/atoms/themeAtom";

export const ThemeProvider = ({ children, ...props }: ThemeProviderProps) => {
  const [theme] = useAtom(themeAtom);

  return (
    <ThemeProviderGravity theme={theme} {...props}>
      {children}
    </ThemeProviderGravity>
  );
};
